import { render, staticRenderFns } from "./BookingSlotsCalendar.vue?vue&type=template&id=194b0ee0&"
import script from "./BookingSlotsCalendar.vue?vue&type=script&lang=js&"
export * from "./BookingSlotsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./BookingSlotsCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports